import gql from 'graphql-tag'
import client from '../../stores/apollo'
import normalize from './normalize'
import { FloorMapSpaceFragment } from '../fragments'
import { IFloorMapSpace, FloorMapSpaces } from '../types'

interface IPayload {
  data: {
    map: {
      spaces: IFloorMapSpace[]
      printableQrCodeUsageTypes: string[]
    }
  }
}

export default function spaces(id: string): Promise<{
  spaces: FloorMapSpaces
  printableQrCodeUsageTypes: string[]
}> {
  const variables = { id }

  return client.gql.query({ query, variables }).then(
    ({
      data: {
        map: { spaces, printableQrCodeUsageTypes },
      },
    }: IPayload) => ({ spaces: normalize(spaces), printableQrCodeUsageTypes })
  )
}

const query = gql`
  query Spaces($id: ID!) {
    map: node(id: $id) {
      ... on Floor {
        printableQrCodeUsageTypes
        spaces {
          spaceAssignment {
            team {
              id
              name
            }
            department {
              id
              name
            }
            neighborhood {
              employees {
                id
                name
              }
            }
            employee {
              id
              name
            }
            sharedEmployees {
              id
              name
            }
          }
          ...FloorMapSpaceFragment
        }
      }
    }
  }
  ${FloorMapSpaceFragment}
`
